import React, { Component } from 'react'
import moment from 'moment'

import _ from 'lodash'

import {
  BarChartByDoubleAttributeRatio,
  PieChartByAttribute,
  TimelineByAttribute,
  BarChartByAttributeRatio,
  TimelineOfDifferentAttributes,
  granularityDescriptor,
} from '../shared/Charts'
import { capitalize } from '../../utils/utils'

export default class ReportCharts extends Component {
  render() {
    // const rp = this.props.report
    // const isPrint = this.props.isPrint

    const data = this.props.data
    const isReportIssuer = this.props.isReportIssuer

    const operators = _.uniqBy(data, 'operatorName').map((d) => d.operatorName)

    const gDescriptorSingular = granularityDescriptor(
      this.props.data[0].opDt,
      this.props.data[this.props.data.length - 1].opDt,
      false
    )
    const gDescriptorPlural = granularityDescriptor(
      this.props.data[0].opDt,
      this.props.data[this.props.data.length - 1].opDt,
      true
    )

    const chartContainerStyle = {
      backgroundColor: 'white',
      borderRadius: '25px',
      paddingTop: '10px',
    }

    const renderPieSST = (aspectRatio) => {
      return (
        <div className="column has-text-centered">
          <div style={chartContainerStyle}>
            <p className="subtitle mb-0 is-size-6">Consumo por Subestação de Tracção (kWh)</p>
            <PieChartByAttribute
              data={data}
              groupAttribute={'sst'}
              sumAttribute={'consumptionTotal'}
              aspectRatio={aspectRatio}
            />
          </div>
        </div>
      )
    }

    const renderPieMotora = (aspectRatio) => {
      return (
        <div className="column has-text-centered">
          <div style={chartContainerStyle}>
            <p className="subtitle mb-0 is-size-6">Consumo por Frota (kWh)</p>
            <PieChartByAttribute
              data={data}
              groupAttribute={'fleetGroup'}
              sumAttribute={'consumptionTotal'}
              aspectRatio={aspectRatio}
            />
          </div>
        </div>
      )
    }

    const renderPieOperador = (aspectRatio) => {
      return (
        <div className="column has-text-centered">
          <div style={chartContainerStyle}>
            <p className="subtitle mb-0 is-size-6">Consumo por Operador (kWh)</p>
            <PieChartByAttribute
              data={data}
              groupAttribute={'operatorName'}
              sumAttribute={'consumptionTotal'}
              aspectRatio={aspectRatio}
            />
          </div>
        </div>
      )
    }

    const renderBarMwhKmFleet = (aspectRatio) => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Consumo médio por Quilómetro por Frota (kWh / km)</p>
          <BarChartByDoubleAttributeRatio
            data={data}
            groupAttribute={'fleetGroup'}
            numeratorAttribute={'consumptionTotal'}
            denominatorAttribute={'kmTraveled'}
            label={'MWh/km'}
            aspectRatio={aspectRatio}
          />
        </div>
      )
    }

    const renderBarMwhKmFleet2 = (aspectRatio) => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Consumo vs Frenagem médio por Quilómetro por Frota (kWh/km)</p>
          <BarChartByDoubleAttributeRatio
            data={data}
            groupAttribute={'fleetGroup'}
            numeratorAttribute1={'consumptionTotal'}
            numeratorAttribute2={'brakingTotal'}
            denominatorAttribute={'kmTraveled'}
            numerator1DisplayName={'Consumo'}
            numerator2DisplayName={'Frenagem'}
            label={''}
            aspectRatio={aspectRatio}
          />
        </div>
      )
    }

    const renderBarMwhKmOperator = (aspectRatio) => {
      return (
        <div className="column has-text-centered">
          <div style={chartContainerStyle}>
            <p className="subtitle mb-0 is-size-6">Consumo médio por Quilómetro por Operador (kWh/km)</p>
            <BarChartByAttributeRatio
              data={data}
              groupAttribute={'operatorName'}
              numeratorAttribute={'consumptionTotal'}
              denominatorAttribute={'kmTraveled'}
              label={'MWh/km'}
              aspectRatio={aspectRatio}
            />
          </div>
        </div>
      )
    }

    const renderBarMwhKmOperator2 = (aspectRatio) => {
      return (
        <div className="column has-text-centered">
          <div style={chartContainerStyle}>
            <p className="subtitle mb-0 is-size-6">Consumo vs Frenagem médio por Quilómetro por Operador (kWh/km)</p>
            <BarChartByDoubleAttributeRatio
              data={data}
              groupAttribute={'operatorName'}
              numeratorAttribute1={'consumptionTotal'}
              numeratorAttribute2={'brakingTotal'}
              denominatorAttribute={'kmTraveled'}
              numerator1DisplayName={'Consumo'}
              numerator2DisplayName={'Frenagem'}
              label={''}
              aspectRatio={aspectRatio}
            />
          </div>
        </div>
      )
    }

    const renderTimelineBySST = () => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Consumo por SST (kWh)</p>
          <TimelineByAttribute
            data={data}
            // year={rp.year}
            // month={rp.month}
            groupbyAttribute={'sst'}
            sumAttribute={'consumptionTotal'}
            aspectRatio={5}
          />
        </div>
      )
    }

    const renderTimelineByService = () => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Consumo por Tipologia de Serviço (kWh)</p>
          <TimelineByAttribute
            data={data}
            // year={rp.year}
            // month={rp.month}
            groupbyAttribute={'service'}
            sumAttribute={'consumptionTotal'}
            aspectRatio={5}
          />
        </div>
      )
    }

    const renderTimelineByFleet = () => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Consumo por Frota (kWh)</p>
          <TimelineByAttribute
            data={data}
            groupbyAttribute={'fleetGroup'}
            sumAttribute={'consumptionTotal'}
            aspectRatio={5}
          />
        </div>
      )
    }

    const renderTimelineByOperator = () => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Consumo por Operador (kWh)</p>
          <TimelineByAttribute
            data={data}
            groupbyAttribute={'operatorName'}
            sumAttribute={'consumptionTotal'}
            aspectRatio={5}
          />
        </div>
      )
    }

    const renderConsumoFrenagem = (aspectRatio, operatorName = undefined) => {
      return (
        <div key={operatorName} style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">
            Consumo vs Frenagem Diário {operatorName ? operatorName : 'Global'} (kWh)
          </p>

          <TimelineOfDifferentAttributes
            data={data}
            attributes={[
              { name: 'consumptionTotal', label: 'Consumo' },
              { name: 'brakingTotal', label: 'Frenagem' },
            ]}
            filters={operatorName && [{ attribute: 'operatorName', value: operatorName }]}
            aspectRatio={aspectRatio}
            // total
          />
        </div>
      )
    }

    const renderConsumoPeriodo = (aspectRatio) => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Consumo vs Frenagem Diário por Período Horário (kWh)</p>
          <TimelineOfDifferentAttributes
            data={data}
            attributes={[
              { name: 'consumptionVazio', label: 'Vazio' },
              { name: 'consumptionSuperVazio', label: 'SuperVazio' },
              { name: 'consumptionPontas', label: 'Pontas' },
              { name: 'consumptionCheias', label: 'Cheias' },
            ]}
            aspectRatio={aspectRatio}
          />
        </div>
      )
    }

    if (isReportIssuer) {
      return (
        <>
          <div className="mx-5">
            <div className="subtitle sie-title-container mt-5">
              <h1 className="subtitle ">Totais</h1>
            </div>

            <div className="columns is-centered is-vcentered my-0">
              {renderPieOperador(2.5)}
              {/* {renderBarMwhKmOperator(2.5)} */}
              {renderBarMwhKmOperator2(2.5)}
            </div>

            <div className="columns is-centered is-vcentered my-0">
              {renderPieSST(2.5)}
              {renderPieMotora(2.5)}
            </div>

            {renderBarMwhKmFleet2(5)}

            <div className="subtitle sie-title-container mt-5">
              <h1 className="subtitle ">Consumo vs Frenagem por Operador</h1>
            </div>

            {operators.map((op) => renderConsumoFrenagem(5, op))}

            {/* {renderBarMwhKmFleet(5)} */}

            <div className="subtitle sie-title-container mt-5">
              <h1 className="subtitle ">Métricas {capitalize(gDescriptorPlural)}</h1>
            </div>

            {renderTimelineByFleet(5)}
            {renderTimelineByOperator(5)}
            {renderTimelineByService(5)}
            {renderTimelineBySST(5)}
          </div>
        </>
      )
    } else {
      const pieAspectRatio = 2.5
      return (
        <div className="mx-5">
          <div className="subtitle sie-title-container mt-5">
            <h1 className="subtitle ">Totais</h1>
          </div>

          <div className="columns is-centered is-vcentered my-0">
            {renderPieSST(2.5)}
            {renderPieMotora(2.5)}
          </div>
          {/* {renderBarMwhKmFleet(5)} */}
          {renderBarMwhKmFleet2(5)}

          {renderConsumoFrenagem(5)}
          {renderTimelineByFleet(5)}
          {renderTimelineByService(5)}
          {renderTimelineBySST(5)}
        </div>
      )
    }
  }
}
